import { createElement } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import Button from '@hfe/max-button';
import styles from './index.module.scss';
import { NEW_BUTTON_BG_SOURCE, PROMOTION_ICON, DEFAULT_FRONT_IMG } from './constants';
import Sensor from '@max/mbc-sensor';
import LImage from '@max/leez-image';
import { rpx2px } from '@hfe/max-universal-unit-tool';
import { useMonitorJumper } from '@nibfe/mcp-monitor-sdk';
import { getRankTagImage } from '../../utils/common';
export default (props) => {
    const { monitorNavigateToSmart } = useMonitorJumper();
    const { vo = {}, index = -1, onCardShow, onCardClick } = props;
    const { goodsName, goodsImage, goodsScore, goodsReview, goodsRecommendReason, goodsDetailUrl, goodsGiftList, goodsOriginalPrice, goodsSellPrice, promotionText, buttonExtraText, isShowBottomTag = false, bottomTagImgSource, tagModelList = [], discountInfo } = vo;
    const rankNum = index + 1;
    const rankingImg = getRankTagImage(index);
    return <Sensor x-if={goodsSellPrice} once onAppear={() => onCardShow(vo, index)} className={styles.containerWrap}>
      
      <View className={styles.cornerTagInfoContainer}>
        <LImage className={styles.cornerTagInfoImg} source={{
        uri: rankingImg
    }} 
    // width={rpx2px(52)}
    // height={rpx2px(62)}
    borderRadius={0}>
          <Text x-if={rankNum > 9} className={styles.cornerTagRankNum}>{rankNum}</Text>
        </LImage>
      </View>
      <Button className={styles.container} style={props.index === 0 ? {
        marginTop: 0
    } : {}} onPress={() => {
        onCardClick(vo, index);
        monitorNavigateToSmart(goodsDetailUrl);
    }}>
        <LImage className={styles.frontImage} width={rpx2px(312)} height={rpx2px(200)} borderRadius={0} resizeMode={'cover'} source={{
        uri: goodsImage ? goodsImage.replace('http:', 'https:').replace('/w.h/', '/') + '@750w' : DEFAULT_FRONT_IMG.uri
    }} style={{
        overflow: 'visible',
        borderTopLeftRadius: rpx2px(24),
        borderTopRightRadius: rpx2px(24)
    }}>
          <View x-if={isShowBottomTag} className={styles.bottomImgTag}>
            <Image source={bottomTagImgSource} borderRadius={0} resizeMode='stretch'/> 
          </View>
        </LImage>
        <View className={styles.contentWrap}>
          <View className={styles.titleWrap}>
            <Text className={styles.title} numberOfLines={2}>
              {goodsName}
            </Text>
          </View>
          
          <View className={styles.tagListWrap} x-else>
              {tagModelList.length > 0 && tagModelList.map((tag, index) => {
        return <View key={`tag_${index}`} className={styles.tag}>
                  <Text className={styles.tagText} numberOfLines={1}>
                    {tag.title}
                  </Text>
                </View>;
    })}
            </View>
          <View className={styles.giftListWrap}>
            {goodsGiftList.map((gift, index) => {
        return <View x-if={gift === null || gift === void 0 ? void 0 : gift.giftText} className={styles.giftWrap} key={`${gift === null || gift === void 0 ? void 0 : gift.giftText}_${index}`}>
                  <LImage width={rpx2px(28)} height={rpx2px(28)} source={{
            uri: gift === null || gift === void 0 ? void 0 : gift.giftIcon
        }} resizeMode="cover" placeholder/>
                  <Text className={styles.giftText} numberOfLines={1}>
                    {gift === null || gift === void 0 ? void 0 : gift.giftText}
                  </Text>
                </View>;
    })}
          </View>

          <View className={styles.buttonWrap}>
            <LImage source={{
        uri: NEW_BUTTON_BG_SOURCE.uri
    }} height={rpx2px(82)} width={rpx2px(276)} resizeMode="contain" borderRadius={0}>
              <View className={styles.showOriginalPriceWrap}>
                <View x-if={goodsSellPrice} className={styles.sellPriceWrap}>
                  <Text className={styles.pricePrefix}>¥</Text>
                  <Text className={styles.price}>{goodsSellPrice}</Text>
                  <Text className={styles.priceSuffix}>起</Text>
                </View>
                <View x-if={discountInfo} className={styles.discountInfoWrap}>
                  <LImage source={{
        uri: PROMOTION_ICON.uri
    }} width={rpx2px(20)} height={rpx2px(20)}/>
                  <Text className={styles.discountInfo}>{discountInfo}</Text>
                </View>
              </View>
            </LImage>
          </View>
        </View>
      </Button>
    </Sensor>;
};
